import { Tokens } from "../api/Client";
import { DomComponentHander } from "./Handler";
export class CardDeleteComponent extends DomComponentHander {
    static Load() {
        document.querySelectorAll('.CardDeleteButton').forEach(btn => {
            btn.addEventListener('click', _ => {
                if (confirm('選択されたカードを削除します。よろしいですか？') === true) {
                    const storeId = Number(btn.getAttribute('data-store-id'));
                    const id = Number(btn.getAttribute('data-id'));
                    Tokens.deleteCard(storeId, id).then(_ => {
                        alert('カードを削除しました');
                        location.reload();
                    }).catch(e => {
                        alert('カードの削除に失敗しました。お手数ですが、時間をおいて再度実行してください。');
                        throw e;
                    });
                }
            });
        });
    }
}
